import { Fragment, useState, useLayoutEffect } from "react";
import { Formik, ErrorMessage } from "formik";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import SideBar from "./SideBar";
import Loader from "../components/Loader";
import { forgotPasswordSchema } from "../ValidationScheema/Yup";
import DraggableSidebar from "../components/DraggableSidebar";
import RightsidebarGreybox from "../components/RightsidebarGreybox";
import { forgotPassword } from "../Store/api/studentAuth";

const intialValues = {
  email: "",
};

export const ForgotPassword = () => {
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [noBookSelect, setNoBookSelect] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    type: "success",
    message: "",
  });
  const [searchParams, setSearchParams] = useSearchParams({
    auth: "instructor",
  });

  const searchParam = searchParams.get("auth");

  useLayoutEffect(() => {
    if (state?.fromState) {
      setSearchParams({ auth: state.fromState });
    }
  }, []);

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      if (searchParam === "student" || searchParam === "instructor") {
        await forgotPassword({ body: { ...values, role: searchParam } });
      }
      setEmailSent(true);
    } catch (error) {
      setErrorMessage({
        type: "danger",
        message: error?.response?.data?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-container">
      <div className="activity-spectrum">
        <div style={{ opacity: 0.5 }}>
          <DraggableSidebar />
        </div>
      </div>
      <div className="w-100">
        <section className="class_room_wrap sidebar-height">
          <div className="custom_container sidebar-height">
            <div className="row sidebar-height">
              <div
                className="col-xxl-3 col-xl-5 col-lg-5 col-md-5 col-sm-12 px-0 pb-0"
                style={{ opacity: 0.7 }}
              >
                <SideBar
                  noBookSelect={true}
                  tabContents='class'
                  searchParam={searchParam}
                  setNoBookSelect={setNoBookSelect}
                />
              </div>
              <div
                className="col-xxl-6 col-xl-7 col-lg-7 col-md-7 col-sm-12"
                style={{ width: "52%" }}
              >
                <div
                  className="welcome_wrap cursor_default"
                  style={{ height: "calc(91vh - 68px)", top: "16%" }}
                >
                  <div className="d-flex flex-column gap-3">
                    {!emailSent && (
                      <Link
                        className="forgot-password-back-btn save-btn text-start text-decoration-none"
                        to={`/?auth=${searchParam}`}
                      >
                        {"<-- Go back"}
                      </Link>
                    )}
                    <h1 className="main_title mb-4 pt-1 forgot-password-title-container">
                      {!emailSent
                        ? "Enter email to send a reset password link"
                        : "check your inbox for an email to continue"}
                    </h1>
                  </div>
                  <div className="row1 d-flex flex-column gap-5 mt-0 pt-0">
                    <Formik
                      initialValues={intialValues}
                      validationSchema={forgotPasswordSchema}
                      onSubmit={onSubmit}
                    >
                      {({ values, handleChange, handleBlur, handleSubmit }) => (
                        <Fragment>
                          {!emailSent && (
                            <div className="col-lg-12 pos-relative">
                              <div className="form-group">
                                <input
                                  type="email"
                                  name="email"
                                  autoComplete="off"
                                  onBlur={handleBlur}
                                  value={values.email}
                                  onChange={handleChange}
                                  className="form-control"
                                  placeholder="Email address"
                                  style={{ backgroundColor: "#ffff" }}
                                />{" "}
                                <div className="err-end w-100">
                                  <p className="error-msg">
                                    <ErrorMessage
                                      className="error-msg"
                                      name="email"
                                    />
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="col-lg-12">
                            <div className="btn_Wrap">
                              {!emailSent && (
                                <>
                                  <button
                                    type="submit"
                                    className="btn_black_theme w-100 d-block mt-2"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                  >
                                    {loading ? (
                                      <div className="loader">
                                        <Loader />
                                      </div>
                                    ) : (
                                      "Send link"
                                    )}
                                  </button>
                                  <div className="mt-20">
                                    {errorMessage.message && (
                                      <div
                                        className={`alert alert-${errorMessage.type}`}
                                      >
                                        {errorMessage.message}
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}
                              {emailSent && (
                                <Link
                                  className="cursor text-decoration-none"
                                  to={`/?auth=${searchParam}`}
                                >
                                  <button
                                    type="button"
                                    className="btn_black_theme w-100 d-block"
                                  >
                                    Return to sign in
                                  </button>
                                </Link>
                              )}
                            </div>
                          </div>
                        </Fragment>
                      )}
                    </Formik>
                  </div>
                </div>

                {!emailSent && (
                  <div
                    style={{
                      paddingLeft: "96px",
                      bottom: "-10%",
                    }}
                    className="footer_bottom"
                  >
                    <p className="have-account">
                      Don't have an account?{" "}
                      <Link
                        to="/?newUser=register"
                        className="cursor text-decoration-underline"
                      >
                        Sign up
                      </Link>
                    </p>
                  </div>
                )}
              </div>
              <div className="col-xxl-1 col-xl-0 col-lg-0 col-md-0 col-sm-0">
                <RightsidebarGreybox className={"abs_gray_cols"} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
